<template>
    <header-index />

    <div class="catalog-wrapper">
        <iframe
            src="https://online.fliphtml5.com/fangyuchuang/2026catalog/"
            class="flipbook-iframe"
            frameborder="0"
            allowfullscreen
            sandbox="allow-scripts allow-same-origin allow-forms"
        ></iframe>
    </div>

    <footer-index />
</template>

<script setup lang="ts" name="SinglePageCatalog">
    import type { SinglePage } from '~/types';
    import headerIndex from '../../components/header/header-index.vue'
    import footerIndex from '../../components/footer/footer-index.vue'
    import toastMessage from '../../components/common/toastMessage.vue'

    const cmsInfo = await cmsUtils.getCmsInfo();
    const route = useRoute()
    const props = defineProps<{
        singlePage: SinglePage
    }>()

    const baseUrl = (cmsInfo.website.https ? 'https://' : 'http://') + cmsInfo.website.domain
    const canonicalUrl = baseUrl + route.path.replace('.html','')

    useHead({
        title: '2026 Catalog - Leafly Packaging',
        meta: [
            { name: 'description', content: 'View our 2026 product catalog' }
        ],
        link: [
            { rel: 'canonical', href: canonicalUrl }
        ],
        style: [
            {
                innerHTML: `.fh5---banner---container { display: none !important; }`
            }
        ]
    });
</script>

<style scoped lang='scss'>
.catalog-wrapper {
    width: 100%;
    height: calc(100vh - 160px);
    background: #383838;
    display: flex;
    justify-content: center;
    align-items: center;
}

.flipbook-iframe {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
</style>
